import { memo, useState } from 'react';

import { type ActivatedAccount } from '@air/analytics';
import { type Account } from '@air/api/types';

import { SignUpModalSSOOrEmailForm } from '~/components/Modals/SignupModal/SignUpModalSSOOrEmailForm';
import { SignUpModalUserDetailsForm } from '~/components/Modals/SignupModal/SignUpModalUserDetailsForm';
import { type SSOCallbackData } from '~/components/PublicSSOCallback/utils';

type SignUpModalFormProps = {
  onSuccess: (account: Account) => void;
  accountCreationSource: ActivatedAccount['creationSource'];
  onLoginClick: () => void;
  closeModal: () => void;
  ssoCallbackData: SSOCallbackData | undefined;
};

export const SignUpModalForm = memo(
  ({ accountCreationSource, onSuccess, onLoginClick, ssoCallbackData, closeModal }: SignUpModalFormProps) => {
    const [submittedEmail, setSubmittedEmail] = useState<string | undefined>();

    if (submittedEmail) {
      return (
        <SignUpModalUserDetailsForm
          email={submittedEmail}
          accountCreationSource={accountCreationSource}
          onSuccess={onSuccess}
          onBackClick={() => setSubmittedEmail(undefined)}
        />
      );
    } else {
      return (
        <SignUpModalSSOOrEmailForm
          onLoginClick={onLoginClick}
          closeModal={closeModal}
          onEmailSubmit={setSubmittedEmail}
          accountCreationSource={accountCreationSource}
          ssoCallbackData={ssoCallbackData}
        />
      );
    }
  },
);

SignUpModalForm.displayName = 'SignUpModalForm';
